export default {
  UPDATE_ISLOADING: Symbol('UPDATE_ISLOADING'),
  UPDATE_DETAIL: Symbol('UPDATE_DETAIL'),
  UPDATE_SIGNATORY: Symbol('UPDATE_SIGNATORY'),
  UPDATE_SHAREHOLDER: Symbol('UPDATE_SHAREHOLDER'),
  UPDATE_CONTRACT: Symbol('UPDATE_CONTRACT'),
  UPDATE_INSURANCE: Symbol('UPDATE_INSURANCE'),
  UPDATE_INSURANCE_FORM: Symbol('UPDATE_INSURANCE_FORM'),
  RESET_INSURNCE_FORM: Symbol('RESET_INSURNCE_FORM'),
  UPDATE_LETTERS: Symbol('UPDATE_LETTERS'),
  UPDATE_SHAREHOLDER_FORM: Symbol('UPDATE_SHAREHOLDER_FORM'),
  UPDATE_ACTIVEKEY: Symbol('UPDATE_ACTIVEKEY'),
  UPDATE_OTHER_MEANS: Symbol('UPDATE_OTHER_MEANS'),
  UPDATE_MEANS_FORM: Symbol('UPDATE_MEANS_FORM'),
  RESET_MEANS_FORM: Symbol('RESET_MEANS_FORM'),
  UPDATE_CORPORATION_DATA: Symbol('UPDATE_CORPORATION_DATA'),
};
